(function() {
    angular.module('tmx-app').controller('usersDynamicCtrl', ['resolvedData','$scope', '$state', '$mdDialog', 'UsersDynamicService', '$mdSidenav', UsersDynamicCtrl]);

    function UsersDynamicCtrl(resolvedData,$scope, $state, $mdDialog, UsersDynamicService, $mdSidenav) {
        var userVM = this;
        userVM.checkPermission = tmxUtility.checkPermission;


    ///////////////////FUNCTIONS////////////////////////
        userVM.getDevicePhoneNumber= function(deviceId){
            for(var i=0;i<userVM.Devices.length;i++) {
                if(userVM.Devices[i].HiddenValue==deviceId)
                    return userVM.Devices[i].PhoneNumber;
            }
            return " ";
        }

        userVM.getCompanyType = function(dataitem) {
       
            if (angular.isDefined(UsersDynamicService.type) && UsersDynamicService.type.length > 0) {
                for (var i = UsersDynamicService.type.length - 1; i >= 0; i--) {
                    if (UsersDynamicService.type[i].HiddenValue == dataitem.UserTypeLkp) {
                        return UsersDynamicService.type[i].VisibleValue;
                    }
                }
            }
            return "none";
        };

        userVM.getStatus = function(dataitem) {
            var currentDate = new Date();
            var startDate = kendo.parseDate(dataitem.EffectiveStartDate);
            var endDate = kendo.parseDate(dataitem.EffectiveEndDate);
            if (((endDate - currentDate) >= 0) && ((startDate - currentDate) <= 0))
                return 'Active';
            else
                return 'Inactive';
        };

        userVM.reload = function() {
            userVM.container.userGrid.dataSource.read();
        };

        userVM.success=function(promise){
            if(promise.read==true) {
                userVM.container.userGrid.dataSource.transport.read(promise);
            }
            else {
                userVM.container.userGrid.dataSource.read(); 
            }
            userVM.toggleSearch(userVM.nav);
        };

        userVM.onChildState = function() {
            if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
        };

        userVM.new = function() {
      //.path(.url()+'/new');
            $state.go($state.current.name + ".add");
        };

        userVM.clickEdit = function(item) {
            $state.go($state.current.name + ".edit", {
                "Id": item.UserId
            });
        };

        userVM.formatUserName = function(item) {
            if(item.UserName.length>10) {
                return item.UserName.slice(0,10)+"...";
            }
            return item.UserName;
        };

        userVM.clickCopy = function() {
            $mdDialog.show({
                clickOutsideToClose: true,
                controller: function($mdDialog) {
                    var vm = this;
                    vm.clone = userVM.clone;
          // vm.task = task;  //your task object from the ng-repeat
                    $scope.hide = function() {
                        $mdDialog.hide();
                    };
                    $scope.cancel = function() {
                        $mdDialog.cancel();
                    };
                },
                controllerAs: 'modal',
                templateUrl: 'app/private/clone.html',
                parent: angular.element(document.body),
                targetEvent: e
            });
        }
        var deleteConfirm = function(tid) {
            var confirm = $mdDialog.confirm()
                .title('Delete Company ' + tid.CompanyName + " ?")
                .textContent('Are you sure you want to delete this company?')
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
        // .targetEvent(ev)
                .ok('Yes')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                DeleteCompany(tid);
            }, function() {
            });
        };
        var DeleteCompany = function(tid) {
            tid.$remove().then(function(promise) {
                userVM.container.userGrid.dataSource.read();
            });
        };
        userVM.clickDelete = function(item) {
            deleteConfirm(item);
        };
    // userVM.clickDeactivate = function(item) {
    //   item.$deactivate(item.UserId).then(function(promise) {
    //     userVM.container.userGrid.dataSource.read();
    //   });
    // };
    // userVM.clickActivate = function(item) {
    //   item.$activate(item.UserId).then(function(promise) {
    //     userVM.container.userGrid.dataSource.read();
    //   });
    // };
        userVM.clickDeactivate = function(item) {
            var confirm = $mdDialog.confirm()
                .title('Deactivate User '+item.UserName+" ?")
                .textContent('Are you sure you want to deactivate this User?')
                .ariaLabel('Deactivate User')
                .clickOutsideToClose(true)
                .ok('Yes')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(
                function() {
                    userVM.Deactivate(item);
                }, function() {
                }
            );
        };
        userVM.clickActivate = function(item) {
            var confirm = $mdDialog.confirm()
                .title('Activate User '+item.UserName+" ?")
                .textContent('Are you sure you want to activate this User?')
                .ariaLabel('Activate User')
                .clickOutsideToClose(true)
                .ok('Yes')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(
                function() {
                    userVM.Activate(item);
                }, function() {
                }
            );
        };
        userVM.Deactivate = function(item) {
            item.$deactivate(item.UserId).then(function(promise) {
                userVM.container.userGrid.dataSource.read();
            });
        };
        userVM.Activate = function(item) {
            item.$activate(item.UserId).then(function(promise) {
                userVM.container.userGrid.dataSource.read();
            });
        };
        userVM.isStatusActive = function(dataitem) {
       
            if (userVM.getStatus(dataitem) == "Active")
                return true;
            else
                return false;
        };
        userVM.onClick = function(e, dataItem) {
            var element = $(e.currentTarget);
            var checked = element.is(':checked');
            var row = element.closest("tr");
            if (checked) {
                row.addClass("k-state-selected");
                userVM.addToBulk(dataItem);
            }
            else {
                row.removeClass("k-state-selected");
                userVM.removeFromBulk(dataItem);
            }
        };
        userVM.addToBulk = function(dataItem) {
            userVM.bulk.push(dataItem);
        };
        userVM.removeFromBulk = function(dataItem) {
            for (var i = userVM.bulk.length - 1; i >= 0; i--) {
                if (userVM.bulk[i].CompanyId === dataItem.CompanyId) {
                    userVM.bulk.splice(i, 1);
                }
            }
        };
        userVM.bulkDelete = function() {
            var confirm = $mdDialog.confirm()
                .title('Bulk Delete')
                .textContent('Are you sure you want to delete ' + userVM.bulk.length + ' companies?')
                .ariaLabel('Lucky day')
                .clickOutsideToClose(true)
        // .targetEvent(ev)
                .ok('Yes')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                UsersDynamicService.bulkDelete(userVM.bulk);
            }, function() {
            });
        };
        userVM.toggleSearch = function() {
            if (userVM.searchSideNavActive) {
        // userVM.searchData = {};
                userVM.searchSideNavActive = false;
            }
            else
                userVM.searchSideNavActive = true;
            userVM.toggle('SearchSideNav');
        }
        userVM.toggleExport = function() {
            if (userVM.exportSideNavActive)
                userVM.exportSideNavActive = false;
            else
                userVM.exportSideNavActive = true;
            userVM.toggle('ExportSideNav');
        }
        userVM.isOpen = function(navID) {
            return $mdSidenav(navID).isOpen();
        };
        userVM.toggle = function(navID) {
            $mdSidenav(navID)
                .toggle()
                .then(function() {});
        };
        userVM.search = function(navID) {
            calls = [];
            for (var key in userVM.searchData) {
                if (userVM.searchData.hasOwnProperty(key)) {
                    calls.push({
                        field: key,
                        operator: "contains",
                        value: userVM.searchData[key]
                    });
                }
            }
            userVM.filt = {
                filters: calls,
                logic: "and"
            };
      // userVM.searchObject.data.filter=userVM.filt;
            userVM.o.data.filter = userVM.filt;
      // UsersDynamicService.getByParams(userVM.searchObject,true).then(function(response){
      //               userVM.container.userGrid.dataSource.data(response.data);
      //               // userVM.container.userGrid.dataSource.read();
      //               // o.success(response)
      //             });
            userVM.container.userGrid.dataSource.transport.read(userVM.o);
      // userVM.searchData = {};
            userVM.toggle(navID);
        };
        userVM.clear = function(navID) {
      // userVM.searchData = {};
            userVM.toggle(navID);
        };
        userVM.clearSideNav = function(navID) {
            userVM.searchData = {};
        };
    ////////////////////////////////////////////////////

    
    //////////////////////CODE//////////////////////////
        userVM.query = "User"
        userVM.UsersDynamicService = UsersDynamicService;
        userVM.cols = UsersDynamicService.gridColumn;
        userVM.nav = "SearchSideNav";
        userVM.schema = UsersDynamicService.schema;
        userVM.Devices = resolvedData.Devices.data;
        userVM.date = new Date().toJSON();
        userVM.gridData = new kendo.data.ObservableArray([]);
        userVM.cloneColumn = angular.copy(UsersDynamicService.gridColumn);
        userVM.clone = 0;
        userVM.dataObj = {
            value: "empty"
        };
        userVM.gridColumns = angular.copy(UsersDynamicService.columns);
        userVM.gridColumns[3].template = "\{\{UsersDynamicCtrl.getCompanyType(dataItem)\}\}";
        userVM.gridColumns[4].template = "\{\{UsersDynamicCtrl.getCompanyType(dataItem)\}\}";
        userVM.gridColumns[5].template = "\{\{UsersDynamicCtrl.getStatus(dataItem)\}\}";
        userVM.gridColumns.push({
            title: "",
            width: "5%",
            template: "<md-menu md-position-mode=\"target-right target\" flex='none' class='menu-list-item' ><md-button  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button><md-menu-content width='2' ><!--md-menu-item><md-button ng-disabled='UsersDynamicCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='UsersDynamicCtrl.clickEdit(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>edit</md-icon>Edit User</md-button></md-menu-item--><md-menu-item ng-if='!UsersDynamicCtrl.isStatusActive(dataItem)'><md-button aria-label='del' class='tmxMin' ng-click='UsersDynamicCtrl.clickActivate(dataItem,$event)'> <md-icon class='md-accent material-icons menu-list-item'>add_circle</md-icon>Activate User</md-button></md-menu-item><md-menu-item ng-if='UsersDynamicCtrl.isStatusActive(dataItem)' ><md-button  aria-label='del' class='tmxMin' ng-click='UsersDynamicCtrl.clickDeactivate(dataItem,$event)'> <md-icon class='md-accent material-icons menu-list-item'>remove_circle</md-icon>Deactivate User</md-button></md-menu-item></md-menu-content></md-menu>"
        });
        userVM.mainGridOptions = {
            dataSource: {
                transport: {
                    read: function(o) {
                        userVM.searchClear = false;
                        if(userVM.onChildState()){return;}
                        if(!o.fromSideNav) {
                            if($state.searchClear){
                                userVM.searchClear = true;
                                $state.searchClear=undefined;
                      //return;
                            }
                  //if(exists(companyVM.o)){
                  //copy(companyVM.o.data,["filter"],o.data);
                  //}
                        }
                        else{
                            o.data.firstPage = true;
                        }

                        userVM.o = angular.copy(o);
                        UsersDynamicService.getByParams(o, true).then(function(response) {
                            o.success(response)
                        });
                    },
                    dataType: "json"
                },
                schema: {
                    data: "data",
                    total: "Total"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                sort:  [{field: "EffectiveEndDate", dir: "desc"}/*,{field: "CreatedDate", dir: "desc"}*/],
            },
      // selectable: "multiple, row",
            pageable: {
                refresh: true,
                pageSizes: true,
                pageSize: 10,
                buttonCount: 5
            },
            pdf: {
                allPages: true,
                fileName: "Users.pdf"
            },
            excel: {
                allPages: true,
                fileName: "Users.xlsx"
            },
            sortable: {
                mode: "multiple",
                allowUnsort: true
            },
            scrollable: false,
      //rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': UsersDynamicCtrl.isStatusActive(dataItem)}\"><td><input type='checkbox' class='checkbox' ng-click='UsersDynamicCtrl.onClick($event,dataItem)' /> </td><td>#= CompanyCode # </td><td>#= CompanyName # </td><td>#= CompanyTypeLkp # </td><td><md-button ng-disabled='UsersDynamicCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='UsersDynamicCtrl.clickDelete(dataItem)'> <md-icon md-svg-src='assets/images/garbage12.svg' /></md-button><md-button ng-disabled='UsersDynamicCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='UsersDynamicCtrl.clickEdit(dataItem)'> <md-icon md-svg-src='assets/images/edit45.svg' /></md-button><tmx-duplicate disable='UsersDynamicCtrl.isStatusActive(dataItem)' model='dataItem' schema='UsersDynamicCtrl.schema' columns='UsersDynamicCtrl.cloneColumn' on-submit='UsersDynamicCtrl.reload()'> </tmx-duplicate></td></tr>",
            columns: userVM.gridColumns
        };
        userVM.bulk = [];
        userVM.container = {};
        $state.data = {
            grid: userVM.container
        };
        userVM.searchSideNavActive = false;
        userVM.exportSideNavActive = false;
        userVM.filt = {};
    ////////////////////////////////////////////////////
    }
})();
